import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { PillGroup } from './PillGroup.js';
import LabeledDropdownSinglePill from './LabeledDropdownPillsTypes/LabeledDropdownSinglePill.js';
import LabeledDropdownMultiPills from './LabeledDropdownPillsTypes/LabeledDropdownMultiPill.js';
import LabeledDropdownCascadeMenuPill from './LabeledDropdownPillsTypes/LabeledDropdownCascadeMenuPill.js';
import '@elliemae/ds-classnames';
import '@elliemae/ds-shared/FocusGroup/FocusGroupManager';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'prop-types';
import '@elliemae/ds-utilities/hooks/usePrevious';
import '@elliemae/ds-utilities/hooks/useShouldRecalculate';
import '@elliemae/ds-utilities/utils';
import './DropdownPill.js';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-icons/ChevronDown';
import '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';
import './Pill.js';
import './InputPill.js';
import '@elliemae/ds-icons/CloseXsmall';
import '@elliemae/ds-form/InputMask';
import '@elliemae/ds-form/Input';
import './RemovablePill.js';
import './LabeledDropdownPillsTypes/utils.js';
import 'lodash';
import './OverflowPill.js';
import '@elliemae/ds-tooltip';
import '@babel/runtime/helpers/esm/toConsumableArray';

var DropdownPills = {
  single: LabeledDropdownSinglePill,
  multi: LabeledDropdownMultiPills,
  cascaded: LabeledDropdownCascadeMenuPill
};

var createDropdownPill = function createDropdownPill(type) {
  return DropdownPills[type] || DropdownPills.single;
};

function LabeledDropdownPills(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      value = _ref.value,
      type = _ref.type,
      onFocusNextGroup = _ref.onFocusNextGroup,
      onFocusPreviousGroup = _ref.onFocusPreviousGroup,
      onFocusGroupSet = _ref.onFocusGroupSet,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      fixed = _ref.fixed,
      menuProps = _objectWithoutProperties(_ref, ["label", "value", "type", "onFocusNextGroup", "onFocusPreviousGroup", "onFocusGroupSet", "maxWidth", "minWidth", "fixed"]);

  var Component = createDropdownPill(type);
  return /*#__PURE__*/React.createElement(PillGroup, {
    onFocusGroupSet: onFocusGroupSet,
    onFocusNextGroup: onFocusNextGroup,
    onFocusPreviousGroup: onFocusPreviousGroup
  }, /*#__PURE__*/React.createElement(Component, _extends({}, menuProps, {
    label: label,
    maxWidth: maxWidth,
    minWidth: minWidth,
    value: value,
    fixed: fixed
  })));
}

var props = {
  /** pill type */
  type: PropTypes.oneOf(['single', 'multi', 'cascaded']).description('pill type'),

  /** focus next group callback */
  onFocusNextGroup: PropTypes.func.description('focus next group callback'),

  /** focus prev group callback */
  onFocusPreviousGroup: PropTypes.func.description('focus prev group callback'),

  /** focus group set callback */
  onFocusGroupSet: PropTypes.func.description('focus group set callback'),

  /** pill max width */
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('pill max width'),

  /** pill min width */
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('pill min width'),

  /** fixed pill */
  fixed: PropTypes.bool.description('fixed pill'),

  /** pill label text */
  label: PropTypes.string.isRequired.description('pill label text'),

  /** pill value */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string
  })), PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string
  })]).description('pill value')
};
LabeledDropdownPills.propTypes = props;
var DSLabeledDropdownPillsWithSchema = describe(LabeledDropdownPills);
DSLabeledDropdownPillsWithSchema.propTypes = props;

export { DSLabeledDropdownPillsWithSchema, LabeledDropdownPills };
//# sourceMappingURL=LabeledDropdownPills.js.map
